import { render } from "./FoodMenuTestContainer.vue?vue&type=template&id=221bf60b&scoped=true&ts=true"
import script from "./FoodMenuTestContainer.vue?vue&type=script&lang=ts"
export * from "./FoodMenuTestContainer.vue?vue&type=script&lang=ts"

import "./FoodMenuTestContainer.vue?vue&type=style&index=0&id=221bf60b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221bf60b"]])

export default __exports__